import { StackView, Box } from '@planningcenter/tapestry-react';
import React, { useState, useEffect, Fragment } from 'react';
import { logChatPromiseExecution } from 'stream-chat';
import { useChatContext, Channel, Window, MessageInput as MessageInput$1, MessageList } from 'stream-chat-react';
import { noop } from '../../utils/index.js';
import { useChat } from '../../hooks/use_chat.js';
import '../../chat_api_context.js';
import '@planningcenter/url';
import '@planningcenter/jolt-client';
import { INDICATOR_STYLES } from '../../vendor/topbar/components/scroll_container.js';
import { CustomEmptyStateIndicator } from './custom_empty_state_indicator.js';
import { InjectableCustomHeader, CustomHeader } from './custom_header.js';
import { CustomMessageStatus } from './custom_message_status.js';
import { customReactionOptions } from './custom_reaction_options.js';
import { emojiSearchIndex } from './emoji_data.js';
import { MessageInput } from './message_input.js';

const ChannelView = () => {
    var _a, _b;
    const { client, channel } = useChatContext();
    const { closeDrawer, navigation } = useChat();
    const title = ((_a = channel === null || channel === undefined ? undefined : channel.data) === null || _a === undefined ? undefined : _a.name) || "Channel name";
    const [, updateCount] = useState(0);
    const [overflowTop, setOverflowTop] = useState(false);
    const [overflowBottom, setOverflowBottom] = useState(false);
    // force a render when the channel gets updated
    useEffect(() => {
        if (!channel)
            return noop;
        const handleUpdate = (event) => {
            const isUpdated = channel && channel.cid === event.cid;
            isUpdated && updateCount((c) => c + 1);
        };
        client.on("channel.updated", handleUpdate);
        return () => client.off("channel.updated", handleUpdate);
    }, [channel === null || channel === undefined ? undefined : channel.cid]);
    const hasMessages = !!((_b = channel === null || channel === undefined ? undefined : channel.data) === null || _b === undefined ? undefined : _b.last_message_at);
    const sharedProps = {
        channel,
        closeDrawer,
        navigation,
        title,
    };
    const scrollProps = {
        overflowBottom,
        overflowTop,
        setOverflowBottom,
        setOverflowTop,
    };
    return (React.createElement(StackView, { grow: 1, shrink: 1 },
        React.createElement(Channel, { Input: MessageInput, EditMessageInput: MessageInput, emojiSearchIndex: emojiSearchIndex, EmptyStateIndicator: CustomEmptyStateIndicator, reactionOptions: customReactionOptions, doMarkReadRequest: (channel) => navigation.isChannelViewActive &&
                logChatPromiseExecution(channel.markRead(), "mark read"), MessageStatus: CustomMessageStatus },
            React.createElement(Window, null,
                hasMessages ? (React.createElement(WithMessages, { ...sharedProps, ...scrollProps })) : (React.createElement(NoMessages, { ...sharedProps })),
                React.createElement(Box, { position: "relative" },
                    overflowBottom && (React.createElement(Box, { ...INDICATOR_STYLES.bottom, bottom: "unset", height: 1, left: -1, pointerEvents: "none", position: "absolute", right: -1, role: "presentation", top: -1, zIndex: 10 })),
                    React.createElement(MessageInput$1, { disableMentions: true, grow: true }))))));
};
const WithMessages = ({ channel, closeDrawer, overflowTop, setOverflowBottom, setOverflowTop, navigation, title, }) => (React.createElement(MessageList, { head: React.createElement(Fragment, { key: "custom-head" },
        React.createElement(InjectableCustomHeader, { channel: channel, closeDrawer: closeDrawer, setOverflowBottom: setOverflowBottom, setOverflowTop: setOverflowTop, switchToChannelDetailsView: navigation.switchToChannelDetailsView, switchToChannelListView: navigation.switchToChannelListView, title: title }),
        overflowTop && (React.createElement(Box, { ...INDICATOR_STYLES.top, height: 1, left: -1, pointerEvents: "none", position: "absolute", right: -1, role: "presentation", top: "unset", zIndex: 10 }))), messageActions: ["edit", "delete", "react"] }));
const NoMessages = ({ channel, closeDrawer, navigation, title }) => (React.createElement(React.Fragment, null,
    React.createElement(CustomHeader, { channel: channel, closeDrawer: closeDrawer, switchToChannelDetailsView: navigation.switchToChannelDetailsView, switchToChannelListView: navigation.switchToChannelListView, title: title }),
    React.createElement(MessageList, { messageActions: ["edit", "delete", "react"] })));

export { ChannelView };
//# sourceMappingURL=index.js.map
